import {createSvgIcon} from '../create-svg-icon';

export const SwapHorizIcon = createSvgIcon(
  <path d="M6.99 11 3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" />
, 'SwapHorizOutlined');
